import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IUserProfile} from 'app/models/user/user-profile';
import { IUser } from '@shared/models/user';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  }),
  withCredentials: true
};

@Injectable({providedIn: 'root'})

export class UserService {

  private userProfileApi: string = environment.privateApi + 'UserProfile/';
  private userAdministraitonApi: string = environment.privateApi + 'UserAdministration/';

  constructor(private httpClient: HttpClient) { }

  getUserInfo(): Observable<IUserProfile>{
    return this.httpClient.get<IUserProfile>(this.userProfileApi + "GetUserProfile");
  }

  udpateUserInfo(user: IUserProfile): Observable<IUserProfile>{
    return this.httpClient.post<IUserProfile>(this.userProfileApi + "UpdateUserProfile", user);
  }

  getUsers(accountType: string): Observable<IUser[]> {
    return this.httpClient.get<IUser[]>(this.userAdministraitonApi + 'users/' + accountType,  { withCredentials: true });
  }

  getUser(email: string): Observable<IUser> {
    return this.httpClient.get<IUser>(this.userAdministraitonApi + 'user/' + email,  { withCredentials: true });
  }

  removeUser(username: string): Observable<boolean> {
    return this.httpClient.get<boolean>(this.userAdministraitonApi + 'user/remove/' + username,  { withCredentials: true });
  }

  findUser(filter: string) : Observable<IUser> {
    return this.httpClient.get<IUser>(this.userAdministraitonApi + 'user/find/' + filter,  { withCredentials: true });
  }

  getRoles() : Observable<string[]> {
    return this.httpClient.get<string[]>(this.userAdministraitonApi + 'roles' ,  { withCredentials: true });
  }

  addUser(user: IUser) : Observable<any> {
    return this.httpClient.post<any>(this.userAdministraitonApi + 'user/add', user, httpOptions);
  }

  saveUser(user: IUser) : Observable<any> {
    return this.httpClient.post<any>(this.userAdministraitonApi + 'user/save', user, httpOptions);
  }

  updateUser(user: IUserProfile): Observable<IUserProfile> {
    return this.httpClient.post<IUserProfile>(this.userProfileApi + 'CreateUser', user);
  }
}
